import { useEffect, useState } from "react";
import { Table, Button, Tooltip, Input } from "antd";
import { YHModal } from "@/components/YHModal";
import { YhBox } from "@/components/YhBox";
import { ColumnsType, TablePaginationConfig } from "antd/es/table";
import { DEFAULT_PAGE_SIZE, DEFAULT_FIRST_PAGE_NUM } from "@/utils/constants";
import { ISearchPage } from "@/types/ScmTypes";
import { transPgToPagination, momentFormat, repairFormatNum } from "@/utils/utils";
import useGlobalModel from "@/model/globalModel";
import YhTootip from "@/components/YhTootip";
import { enquiryService } from "../workHourService";
import { sourceAppOrBranch } from "@/types/VrmSaDictEnums";
import { useWorkHourModel } from "../workHourModel";
import { SearchOutlined } from "@ant-design/icons";

interface IRepairHistoryType {
    visible: boolean,
    code?: string,
    onCancel: () => void
}

export const DetailModel = ({
    visible,
    code = "",
    onCancel,
}: IRepairHistoryType) => {
    const { shopAndOrg } = useGlobalModel(({ shopAndOrg }) => [shopAndOrg]);
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const { searchParam, setSearchParam } = useWorkHourModel();
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    const totalPgCfg = { pageSize: -1, pageNum: 1 }
    const [searchVal, setSearchVal] = useState<any>({})
    const [dataSource, setDataSource] = useState<any[]>([]);
    // 新增车牌号搜索状态
    const [plateNumber, setPlateNumber] = useState('');

    useEffect(() => {
        if (visible) {
            // 初始加载时重置搜索条件
            setPlateNumber('');
            loadData(initPgCfg, { code })
            setSearchVal({ code })
        }
    }, [visible])

    const loadData = async (page?: ISearchPage, searchValue: any = searchVal) => {
        let searchParams = {
            ...searchValue,
            ...searchParam,
            ...shopAndOrg,
            ...sourceAppOrBranch,
            // 添加车牌号搜索条件
            licensePlate: plateNumber,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await enquiryService.workHourStaticDetail(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
    }

    // 新增搜索处理函数
    const handleSearch = () => {
        // 搜索时重置到第一页
        loadData({ ...initPgCfg, current: 1 }).then();
    }

    // 新增回车搜索支持
    const handleKeyPress = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    }

    const columns: ColumnsType<any> = [
        {
            title: '序号',
            width: 40,
            fixed: "left",
            align: 'center',
            render: (t, r, i) => i + 1
        }, {
            title: '姓名',
            width: 80,
            dataIndex: 'technicianName',
            align: 'center',
        }, {
            title: '工单单号',
            width: 170,
            dataIndex: 'maintenanceCode',
            align: 'center',
        }, {
            title: '车牌号',
            width: 130,
            dataIndex: 'licensePlate',
            align: 'center',
        }, {
            title: '维修类型',
            dataIndex: 'serviceNatureName',
            width: 120,
            align: 'center',
        }, {
            title: '分配维修工',
            width: 150,
            dataIndex: 'technicianNames',
            align: 'center',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '完工时间',
            width: 150,
            dataIndex: 'completeTime',
            align: 'center',
        }, {
            title: '单据工时数',
            width: 130,
            dataIndex: 'workHours',
            align: 'center',
        }, {
            title: '分配点数',
            width: 80,
            dataIndex: 'assignPoints',
            align: 'center',
        }, {
            title: '工单占比量',
            width: 120,
            dataIndex: 'proportion',
            align: 'center',
        }, {
            title: '工时数',
            width: 80,
            dataIndex: 'workHour',
            align: 'center',
        }
    ]

    return (
        <YHModal
            visible={visible}
            onCancel={onCancel}
            title="工时明细"
            width={'50%'}
            bodyHeight={600}
            showFooter={false}
        >
            <YhBox title={""}>
                {/* 新增搜索区域 */}
                <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'flex-end' }}>
                    <Input
                        placeholder="请输入车牌号搜索"
                        value={plateNumber}
                        onChange={(e) => setPlateNumber(e.target.value)}
                        onKeyPress={handleKeyPress}
                        style={{ width: 200, marginRight: 8 }}
                        allowClear
                    />
                    <Button
                        type="primary"
                        icon={<SearchOutlined />}
                        onClick={handleSearch}
                    >
                        搜索
                    </Button>
                </div>

                <Table
                    bordered
                    columns={columns}
                    dataSource={dataSource}
                    pagination={{
                        ...pgCfg,
                        position: ["bottomCenter"],
                        showTotal: () => `共${pgCfg.total}条`,
                        onChange: (pageNum, pageSize) => {
                            loadData({ pageNum, pageSize }).then();
                        }
                    }}
                    scroll={{ x: 'max-content', y: 650 }}
                />
            </YhBox>
        </YHModal>
    )
}
